<template>
    <div>
        <section class="form-section" v-if="usersExists">
            <div class="form-section-heading">
                {{ trans('user_groups.headline.license_information') }} -
                {{
                    trans('licenses.label.required_licenses_with_amount', {
                        amount: requiredLicenseAmount,
                    })
                }}
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <label class="label" for="client">{{
                        trans('courses.label.debit_from')
                    }}</label>
                    <select
                        class="input"
                        name="client_id"
                        v-model="selectedClient"
                        @change="recalculateLicenseAmount()"
                    >
                        <option value="">{{
                            trans('courses.label.select')
                        }}</option>
                        <option
                            :value="client.id"
                            v-for="client in clients"
                            :key="client.id"
                            :disabled="
                                client.license_plan == 'license_plan_alpha' &&
                                    (client.license_amount == 0 ||
                                        requiredLicenseAmount >
                                            client.license_amount)
                            "
                        >
                            {{ client.prefixed_name }}
                            {{
                                client.license_plan == 'license_plan_alpha'
                                    ? '(' +
                                      trans('licenses.label.amount') +
                                      ': ' +
                                      client.license_amount +
                                      ')'
                                    : ''
                            }}
                        </option>
                    </select>

                    <input
                        type="hidden"
                        name="client_id"
                        v-model="selectedClient"
                        hidden
                    />
                </div>

                <div class="form-row__col">
                    <form-date
                        name="start_date"
                        :initial-date="new Date(Date.now())"
                        v-model="datepicker.startDate"
                        :min-date="minDate"
                    >
                        {{ trans('courses.label.start_date') }}
                    </form-date>
                </div>

                <div class="form-row__col">
                    <form-date
                        name="end_date"
                        v-model="datepicker.endDate"
                        :min-date="minDate"
                    >
                        {{ trans('courses.label.end_date') }}
                    </form-date>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="section-heading">
                {{ trans('user_groups.headline.course_list') }}
            </div>

            <div class="assignable-courses">
                <select-vue-table
                    :table-data-route="
                        this.route(
                            'tenantapi.clients.user-groups.courses.assign',
                            {
                                client: this.clientId,
                                user_group: this.userGroup.id,
                            }
                        )
                    "
                    :customColumns="['cls_column', 'title']"
                    :options="options"
                    type="checkbox"
                >
                    <colored-letter-square
                        slot="cls_column"
                        slot-scope="props"
                        :name="props.row.title"
                        :length="1"
                    >
                    </colored-letter-square>
                </select-vue-table>
            </div>

            <input
                type="text"
                :value="JSON.stringify(selectedCourses)"
                name="courses"
                hidden
            />
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button
                    type="submit"
                    :disabled="
                        currentLicenseAmount < 0 ||
                        selectedCourses.length == 0 ||
                        (selectedClient == '' && usersExists)
                            ? true
                            : false
                    "
                    class="btn btn--big btn--primary"
                >
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
var axios = require('axios');
import { Event } from 'vue-tables-2';
import { Pagination, PaginationEvent } from 'vue-pagination-2';
import { EventBus } from '../eventbus.js';

export default {
    props: ['clientId', 'usersExists', 'userGroup'],

    data() {
        return {
            originalClients: [],
            clients: [],
            tableData: [],
            selectedClient: '',
            selectedCourses: [],
            currentLicenseAmount: 0,
            options: {
                headings: {
                    checkbox: '',
                    cls_column: '',
                    title: this.trans('courses.label.title'),
                    count_users: this.trans('courses.label.count_users'),
                    count_variations: this.trans(
                        'courses.label.count_variations'
                    ),
                },
                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },
                sortable: [],
            },
            datepicker: {
                startDate: new Date(),
                preSelectedDate: new Date(),
            },
            minDate: new Date(Date.now()),
        };
    },

    computed: {
        requiredLicenseAmount() {
            return this.usersExists * this.selectedCourses.length;
        },
    },

    methods: {
        /**
         * If license amount of selected debit client is not enough reset debit client selection.
         */
        resetDebitClientField() {
            this.getOriginalClientData();

            var client = this.clients.find(client => {
                return client.id == this.selectedClient;
            });

            if (client && client.license_amount) {
                let clientsLicenseAmount = client.license_amount;

                if (clientsLicenseAmount < this.requiredLicenseAmount) {
                    this.selectedClient = '';
                }
            }
        },

        /**
         * Fetches clients which can be selected for debiting.
         */
        fetchClientsforDebitLicense() {
            axios
                .get(
                    this.route('tenantapi.clients.debit.clients', {
                        client: this.clientId,
                    })
                )
                .then(response => {
                    this.clients = response.data;
                    // Deep copy clients object without any reference
                    this.originalClients = JSON.parse(
                        JSON.stringify(response.data)
                    );
                })
                .catch(error => {
                    console.log(error);
                });
        },

        getOriginalClientData() {
            // Deep copy clients object without any reference
            this.clients = JSON.parse(JSON.stringify(this.originalClients));
        },

        /**
         * Recalculate license amount after selecting debit client.
         */
        recalculateLicenseAmount() {
            this.getOriginalClientData();

            var client = this.clients.find(client => {
                return client.id == this.selectedClient;
            });

            if (client) {
                client.license_amount -= this.requiredLicenseAmount;
                this.currentLicenseAmount = client.license_amount;
            } else {
                this.currentLicenseAmount = 0;
            }
        },

        /**
         * Preselect own client as debit client
         */
        preSelectOwnClientAsDebitClient() {
            this.selectedClient = this.userGroup.client_id;
        },
    },

    created() {
        this.fetchClientsforDebitLicense();
        this.preSelectOwnClientAsDebitClient();

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('selected', selectedCourses => {
            this.selectedCourses = selectedCourses;
            this.recalculateLicenseAmount();
        });
    },
};
</script>
